import React, { useEffect } from "react";
import "./Alert.scss";

function Alert({ message, visible, onClose }) {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => onClose(), 2000);
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  return <div className={`alert ${visible ? "show" : ""}`}>{message}</div>;
}

export default Alert;
